// @flow
import React from 'react';
import { withRouter } from 'react-router-dom';
import { StringUtil } from 'utils/StringUtil';
import { RouteUtil } from 'utils/RouteUtil';
// eslint-disable-next-line
import styles from "./styles.scss";

type Info = {
  title: string,
  link: string,
};

type Props = {
  links: Array<Info>,
  history: Object,
  connectRoute: boolean,
  selected_link: Object,
};

const InfoLinks = (props: Props) => {
  const {
    links,
    selectedLinkId,
    connectRoute,
    selected_link,
    sectionType,
  } = props;
  const navigateToLink = (id, title) => {
    if (connectRoute) {
      const routeName = StringUtil.camelCaseString(title);
      RouteUtil.setRouteChange(props, `/${routeName}`);
    } else selected_link(id, title);
  };

  return (
    <ul className={'info-links-container'}>
      {links.map((link, idx) => (
        <li key={idx} onClick={() => navigateToLink(link.id, link.title)}>
          {sectionType === 'features' ? (
            <a
              className={`info-link bold ${
                selectedLinkId === link.id ? 'active-tab' : ''
              }`}
            >
              {link.heading}
            </a>
          ) : (
            <a
              className={`info-link bold ${
                selectedLinkId === link.id ? 'active-tab' : ''
              }`}
            >
              {link.title}
            </a>
          )}
        </li>
      ))}
    </ul>
  );
};

const infoLinks = withRouter(InfoLinks);
export { infoLinks as InfoLinks };
